/* @flow */
import React, { Component } from 'react';
import { Field, reset } from 'redux-form';

import TextInput from './../../../Inputs/TextInput';
import CardInput from './../../../Inputs/CardInput';
import ExpiryInput from './../../../Inputs/ExpiryInput';
import CvcInput from './../../../Inputs/CvcInput';
import i18n from '../../../../../i18n/i18n.js';
import { required } from './../../../../../utils/validators';

type Props = {
    branding: {
        paywall_primary_color: String,
    },
    lng: string,
    name: string,
    active: boolean,
    handleFocus: Function,
};

export default class CardPaymentForm extends Component<Props> {
    componentWillUnmount() {
        //Reset card info - after payment method is changed
        this.props.dispatch(reset('payment'));
    }

    render() {
        const { branding, lng, name, active } = this.props;

        return (
            <div className="formelements cardpayment">
                <Field
                    component={CardInput}
                    name="cardNumber"
                    label={i18n.t('card_number', { lng })}
                    lng={lng}
                    handleFocus={this.props.handleFocus}
                    active={name === 'cardNumber' ? active : false}
                    primaryColor={branding.paywall_primary_color}
                />
                <Field
                    component={TextInput}
                    className="labelholder"
                    type="text"
                    id="cardName"
                    name="cardName"
                    label={i18n.t('cardholder_name', {
                        lng,
                    })}
                    validate={[required]}
                    lng={lng}
                    handleFocus={this.props.handleFocus}
                    active={name === 'cardName' ? active : false}
                    primaryColor={branding.paywall_primary_color}
                    iconName="card-holder"
                />
                <div className="labelholder">
                    <Field
                        component={ExpiryInput}
                        name="expiry"
                        handleFocus={this.props.handleFocus}
                        active={name === 'expiry' ? active : false}
                        primaryColor={branding.paywall_primary_color}
                    />
                    <Field
                        component={CvcInput}
                        name="cvc"
                        handleFocus={this.props.handleFocus}
                        active={name === 'cvc' ? active : false}
                        primaryColor={branding.paywall_primary_color}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Payments/CardPayment/index.js